module.exports = __webpack_public_path__ + "static/img/6.9962c996.png";